/*@flow*/
import L from 'leaflet';
import * as I from 'immutable';
import flatten from 'lib/flatten';

const isEmpty = o => Object.keys(o).length === 0;

// getLatLngs returns the latlngs of each layer in the geojson object
export default (geojson: Object | string): any[] => {
  let latlngs = [];

  if (typeof geojson === 'string') {
    geojson = JSON.parse(geojson);
  } else if (I.Map.isMap(geojson)) {
    geojson = geojson.toJS();
  }

  if (!isEmpty(geojson)) {
    try {
      L.geoJson(geojson).eachLayer(l => {
        if (l.getLatLngs) {
          latlngs.push(...l.getLatLngs());
        } else if (l.getLatLng) {
          latlngs.push(l.getLatLng());
        }
      });
    } catch (e) {
      window.Rollbar.error(e, geojson);
    }
  }

  return flatten(latlngs);
};
